"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayslipService = void 0;
const api_1 = require("./api");
const PATH = '/digitalplayslip/api/v1';
class PlayslipService {
    static async savePlaySlip(playSlip) {
        try {
            return await api_1.API.post({
                url: `${PATH}/digital-playslip`,
                body: playSlip
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async updatePlaySlip(playSlip) {
        try {
            return await api_1.API.put({
                url: `${PATH}/digital-playslip/${playSlip.playSlipId}`,
                body: playSlip
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchPlayslipGamesList() {
        try {
            return await api_1.API.get({
                url: `${PATH}/games/upcoming/draws`
            });
        }
        catch (e) {
            return e;
        }
    }
    static async fetchGames() {
        try {
            return await api_1.API.get({
                url: `${PATH}/games`
            });
        }
        catch (e) {
            return e;
        }
    }
    static async fetchGame(id) {
        try {
            return await api_1.API.get({
                url: `${PATH}/games/${id}`
            });
        }
        catch (e) {
            return e;
        }
    }
    static async fetchSavedPlayslipsList(size) {
        try {
            return await api_1.API.get({
                url: `${PATH}/digital-playslip?page=0&size=${size}`
            });
        }
        catch (e) {
            return e;
        }
    }
    static async deletePlayslip(playslipId) {
        try {
            return await api_1.API.delete({
                url: `${PATH}/digital-playslip/${playslipId}`
            });
        }
        catch (e) {
            return e;
        }
    }
}
exports.PlayslipService = PlayslipService;
//# sourceMappingURL=playslip-service.js.map